import { NavLink } from 'react-router-dom';
import './Header.css';

function formatDate(): string {
  const now = new Date();
  return now.toLocaleDateString('en-GB', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  });
}

export function Header() {
  return (
    <header className="header">
      <div className="container">
        <div className="header__content">
          <h1 className="header__title">
            <span className="header__title-main">TODAY'S NEWS</span>
          </h1>
          <p className="header__date">{formatDate()}</p>
          <nav className="header__nav" aria-label="Main navigation">
            <NavLink
              to="/"
              end
              className={({ isActive }) =>
                ['header__nav-link', isActive ? 'header__nav-link--active' : ''].filter(Boolean).join(' ')
              }
            >
              News
            </NavLink>
            <NavLink
              to="/blogs"
              className={({ isActive }) =>
                ['header__nav-link', isActive ? 'header__nav-link--active' : ''].filter(Boolean).join(' ')
              }
            >
              Blogs
            </NavLink>
          </nav>
        </div>
      </div>
    </header>
  );
}
